import { createContext } from 'react';
import { Doctor, BlogPost, Topic, Specialty } from '../lib/supabase';

interface SearchResults {
  doctors: Doctor[];
  blogPosts: BlogPost[];
  topics: Topic[];
  specialties: Specialty[];
}

interface SearchContextType {
  searchTerm: string;
  searchResults: SearchResults;
  loading: boolean;
  error: string | null;
  performSearch: (term: string) => void;
}

export const SearchContext = createContext<SearchContextType | undefined>(undefined);